var React = require('react');

function IconSort (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.3112 2.75115H0.688791C0.309956 2.75115 0 2.44151 0 2.06307C0 1.68463 0.309956 1.375 0.688791 1.375H10.3112C10.69 1.375 11 1.68463 11 2.06307C11 2.44151 10.69 2.75115 10.3112 2.75115Z","key":0}),React.createElement("path",{"d":"M8.93364 6.19145H2.04573C1.66689 6.19145 1.35693 5.88182 1.35693 5.50338C1.35693 5.12494 1.66689 4.81531 2.04573 4.81531H8.93364C9.31247 4.81531 9.62243 5.12494 9.62243 5.50338C9.62243 5.88182 9.31247 6.19145 8.93364 6.19145Z","key":1}),React.createElement("path",{"d":"M6.86036 9.62493H4.11897C3.74013 9.62493 3.43018 9.31529 3.43018 8.93685C3.43018 8.55841 3.74013 8.24878 4.11897 8.24878H6.86036C7.23919 8.24878 7.54915 8.55841 7.54915 8.93685C7.54915 9.31529 7.23919 9.62493 6.86036 9.62493Z","key":2})]);
}

IconSort.defaultProps = {"viewBox":"0 0 11 11","fill":"none"};

module.exports = IconSort;

IconSort.default = IconSort;
